<template>
    <div class="products-summary">
        <div class="full-container">
            <div class="top-navbar">
                <div class="row align-items-center">
                    <div class="col-md-4">
                     
                    </div> 
                    
                    <div class="col-md-4">
                        <div class="top-navbar-center">
                            Products & Promotions
                            <small class="last-updated">Last updated on {{ latestUpdateTime }}</small>
                        </div>
                    </div>      

                    <div class="col-md-4">
                        <div class="top-navbar-right">
                            <button class="btn btn-ecdc btn-shadow" @click="$router.push({ name: 'productsDetails' })">Product Details</button>
                             <button class="btn btn-ecdc btn-shadow ml-3" @click="$router.push({ name: 'productsPromotionDetails' })">Promotion Details</button>
                        </div>
                    </div>                       
                </div>
            </div>

            <hr />

            <div class="summary-list row row-cols-7">
                <div class="col">
                    <div class="summary-blue-card">
                        <div class="card-content">
                            <h3 class="card-heading">
                                TOTAL PRODUCTS
                            </h3>

                            <div class="figure">
                                {{ productData.totalProduct }}
                                <small>Products</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="summary-blue-card">
                        <div class="card-content">
                            <h3 class="card-heading">
                                TOTAL PROMOTION
                            </h3>

                            <div class="figure">
                                {{ productData.totalPromotion }}
                                <small>Products</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="summary-blue-card">
                        <div class="card-content">
                            <h3 class="card-heading">
                                ACTIVE PROMOTION
                            </h3>

                            <div class="figure">
                                {{ productData.activePromotion }}
                                <small>Products</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="summary-list row row-cols-7">
                <div :key="data.id" class="col" v-for="data in productData.brandProducts">
                    <div class="summary-blue-card">
                        <div class="card-content">
                            <h3 class="card-heading">
                                {{ data.name }}
                            </h3>

                            <div class="figure">
                                {{ data.number }}
                                <small>Products</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <app-loader v-show="isLoading"></app-loader>

    </div>
</template>

<script>
import { checkPermission, getDashboardProduct } from '../api'
import Loader from "./Loader";

export default {
    components: {
        appLoader: Loader,
    },
    data() {
        return {
            latestUpdateTime: new Date().getDate() + "/" + (new Date().getMonth() + 1) + "/" + new Date().getFullYear(),
            restrictViewUsers: false,
            isLoading: true,
            productData: '',
        }
    },
    async mounted() {
        this.restrictViewUsers = await this.checkPermission('restrict users');
        await this.getDashboardProduct();
        this.isLoading = false;
    },
    methods: {
        async checkPermission(permission) {

            try {
                const result = await checkPermission({permission:permission});
                return result.data.data;
            }
            catch(err) {
                return false;
            }
        },
        async getDashboardProduct() {
            let result = await getDashboardProduct();
            this.productData = result.data.data;
        },
    }
}
</script>